module.exports = __webpack_public_path__ + "static/media/orange-arrow-signs.7e6b5963.jpg";